import SchedulingContainer from './SchedulingContainer';

export default SchedulingContainer;



// WEBPACK FOOTER //
// ./src/components/Pages/Appointments/Scheduling/index.js